import { Colors, Switch } from "@blueprintjs/core";
import { css } from "glamor";
import * as React from "react";
import { Link } from "react-router-dom";
import { Collapse, Nav, Navbar, NavbarBrand, NavbarToggler, NavItem } from "reactstrap";

const styles = {
	header: css({
		backgroundColor: Colors.DARK_GRAY5,
		color: Colors.LIGHT_GRAY5 + " !important",
		padding: "10px",
		margin: "0 0 30px 0",
		textAlign: "left",
	}),
	title: css({
		fontSize: "33px",
		fontWeight: "600",
		margin: "5px 0",
	}),
	subtitle: css({
		fontSize: "20px",
		fontWeight: "500",
	}),
	home: css({ fontSize: "34px !important", color: Colors.LIGHT_GRAY5 }),
	link: css({
		paddingTop: "16px",
		fontSize: "18px !important",
		color: Colors.LIGHT_GRAY5,
		marginLeft: "20px",
		":hover": { color: Colors.LIGHT_GRAY4, textDecoration: "underline" },
	}),
	nav: css({ display: "flex", width: "100%", justifyContent: "space-between" }),
	makeBottom: css({ marginTop: "16px" }),
	switch: css({
		marginTop: "2px",
		marginLeft: "40px",
		"@media (max-width: 780px)": {
			marginLeft: "20px",
		},
	}),
};

export default class Header extends React.Component<{ dark: boolean; onChange: () => void }> {
	public state = { isOpen: false };
	public render() {
		return (
			<div {...styles.header}>
				<Navbar dark={true} expand="md">
					<NavbarBrand href="/">
						<div {...styles.home}>SYPT 2019</div>
					</NavbarBrand>
					<NavbarToggler
						onClick={() => {
							this.setState({ isOpen: !this.state.isOpen });
						}}
					/>
					<Collapse isOpen={this.state.isOpen} navbar={true}>
						<Nav className="mr-auto" navbar={true} {...styles.makeBottom}>
							<NavItem>
								<Link
									to="/fightplan/"
									{...styles.link}
									onClick={() => this.setState({ isOpen: false })}
								>
									Fight Plan
								</Link>
							</NavItem>
							<NavItem>
								<Link
									to="/ranking/"
									{...styles.link}
									onClick={() => this.setState({ isOpen: false })}
								>
									Ranking
								</Link>
							</NavItem>
							<NavItem>
								<Link to="/live/" {...styles.link} onClick={() => this.setState({ isOpen: false })}>
									Live
								</Link>
							</NavItem>
							<NavItem>
								<Link
									to="/about/"
									{...styles.link}
									onClick={() => this.setState({ isOpen: false })}
								>
									About
								</Link>
							</NavItem>
							<div {...styles.switch}>
								<Switch
									checked={this.props.dark}
									onChange={this.props.onChange}
									large={true}
									label="Dark mode"
								/>
							</div>
						</Nav>
						<Nav {...styles.makeBottom}>
							<NavItem>
								<Link
									to="/fights/"
									{...styles.link}
									onClick={() => this.setState({ isOpen: false })}
								>
									Fights
								</Link>
							</NavItem>
							<NavItem>
								<Link
									to="/backend/"
									{...styles.link}
									onClick={() => this.setState({ isOpen: false })}
								>
									Backend
								</Link>
							</NavItem>
						</Nav>
					</Collapse>
				</Navbar>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/Header.tsx